/**
 * Hover Zoom+ — enlarge images on hover
 *
 * Exposes a static WAR group to every origin with no `use_dynamic_url`, holding two
 * images (`images/loading.gif`, `images/spectrogram.png`) and five scripts. It also
 * declares site-scoped WAR for DuckDuckGo, the Google TLDs and Vinted, but the
 * every-origin group alone is enough to detect from any page at a fixed URL.
 *
 * The spectrogram image is the primary signal — it loads through `probeImage` with no
 * CORS grant and survives a strict page CSP. The loading GIF and a bundled script
 * corroborate.
 *
 * Manifest verified against version 1.1.15.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'pccckmaobkjjboncdfnnofkonhgpceea';

export const hoverZoom: ExtensionDefinition = {
  id: ID,
  name: 'Hover Zoom+',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Seven static WAR on every origin with no dynamic URL (plus site-scoped extras). ' +
    'Loading spectrogram.png is conclusive and needs no CORS grant; loading.gif and a JS corroborate.',
  signals: [
    {
      id: 'war-spectrogram-png',
      kind: 'web-accessible-resource',
      description:
        'Load images/spectrogram.png via <img> — a bundled image exposed to every ' +
        'origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/spectrogram.png'),
    },
    {
      id: 'war-loading-gif',
      kind: 'web-accessible-resource',
      description: 'Load images/loading.gif via <img> — a second image, corroborating the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/loading.gif'),
    },
    {
      id: 'war-gumby-js',
      kind: 'web-accessible-resource',
      description: 'Fetch js/gumby.js — a bundled script, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/gumby.js'),
    },
  ],
};
